module.exports = __webpack_public_path__ + "img/绿草地新能源LOGO.70aa8837.png";